import {client} from './services/client'

export  const roleusers = {
    namespaced:true,
    state:{
        roleusers:undefined,
        mineroles:[],
    },
    mutations: {
        SET_ROLEUSER (state,roleusers){
            state.roleusers = roleusers
        },
        SET_MINEROLE (state,mineroles){
            state.mineroles = mineroles
        },
        

    },
    actions: {
        get({commit},id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/roleusers/get/'+id,
                })
                    .then((response)=>{
                        let roleusers = response.data.roleusers;
                        console.log(roleusers);
                        commit('SET_ROLEUSER',roleusers)

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },
        set({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/roleusers/save',
                    data:data,
                })
                    .then((response)=>{
                        let roleusers = response.data.roleusers;
                        commit('SET_ROLEUSER',roleusers);

                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        delete({commit},id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/roleusers/delete/'+id,
                })
                    .then((response)=>{
                        let roleusers = response.data.roleusers;
                        commit('SET_ROLEUSER',roleusers);
                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },
        getMineRoles({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/roleusers/mines',
                    data:data,
                })
                    .then((response)=>{
                        let roleusers = response.data.roleusers;
                        commit('SET_MINEROLE',roleusers);
                        console.log("roleusers",roleusers);
                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
    },
    getters: {
        get: state  => {
            return state.roleusers
        },
        getMineroles: state  => {
            return state.mineroles
        },
    }
};
